<div class="factory-popup-container">
    <div class="close-btn-container">
        <div class="close-btn" (click)="close_dialogue('close')" (keydown.enter)="close_dialogue('close')"
            (keydown.space)="close_dialogue('close')">
        </div>
    </div>

    <div class="header-container">
        <div class="factory-header">
            {{'filter_dropdowns.sel_factory' | translate}}
        </div>
    </div>

    <div class="dropdown-container">
        <mat-form-field class="cluster-dropdown" appearance="outline">
            <mat-label>{{'filter_dropdowns.sel_cluster' | translate}}</mat-label>
            <md-input-container>
                <input matInput class="cluster-input" [matAutocomplete]="clusterAutoComplete"
                    [(ngModel)]="filteredData.cluster.searchText" (ngModelChange)="autoComplete($event, 'cluster')"
                    type="text" title="{{filteredData?.cluster?.searchText?.name}}">
            </md-input-container>

            <mat-autocomplete #clusterAutoComplete="matAutocomplete" [displayWith]="clusterValueMapper">
                <mat-option class="cluster-options" [value]="item" *ngFor="let item of uniqueClusterList"
                    title="{{item?.name}}">

                    {{item?.name}}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>

        <mat-form-field class="factory-dropdown" appearance="outline">
            <mat-label>{{'filter_dropdowns.sel_factory' | translate}}</mat-label>
            <md-input-container>
                <input matInput class="factory-input" [matAutocomplete]="factoryAutoComplete"
                    [(ngModel)]="filteredData.factory.searchText" (ngModelChange)="autoComplete($event, 'factory')"
                    type="text" title="{{filteredData?.factory?.searchText?.name}}" [disabled]="factoryDisabled">
            </md-input-container>

            <mat-autocomplete #factoryAutoComplete="matAutocomplete" [displayWith]="factoryValueMapper">
                <mat-option class="factory-options" [value]="item" *ngFor="let item of filteredData.factory.list"
                    title="{{item?.name}}">
                    {{item?.name}}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
    </div>

    <div class="button-container">
        <button mat-flat-button class="select-btn" [ngClass]="{'disabled-btn': disableSubmit}"
            (click)="close_dialogue('select')" [disabled]="disableSubmit">
            {{'search.select' | translate}}
        </button>
    </div>
</div>